"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a CREATE_UPDATE_STREAM_AND_SET request.
 */
var CreateUpdateStreamAndSetRequest = /** @class */ (function () {
    /**
     * Create a new CreateUpdateStreamAndSetRequest instance
     *
     * @param path  the topic path
     * @param topicType  the topic type
     * @param value  the value to set the topic to
     * @param constraint  the update constraint
     */
    function CreateUpdateStreamAndSetRequest(path, topicType, value, constraint) {
        this.path = path;
        this.topicType = topicType;
        this.value = value;
        this.constraint = constraint;
    }
    return CreateUpdateStreamAndSetRequest;
}());
exports.CreateUpdateStreamAndSetRequest = CreateUpdateStreamAndSetRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/create-update-stream-and-set-request.js
// module id = 1668
// module chunks = 1